import React from 'react';
import * as ReactDOM from 'react-dom';
import classnames from 'classnames';
import ModalContainer from './ModalContainer';
class ConfirmModal extends React.Component {
    constructor(props) {
        super(props);
        this.wrapClick = () => {
            if (this.props.maskClick) {
                this.props.maskClick();
            }
        };
        this.transitionShowModal = () => {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.setState({
                    show: true,
                    willHidden: false,
                });
            }, 400);
        };
        this.transitionHiddenModal = () => {
            this.setState({
                willHidden: true,
            });
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.setState({
                    show: false,
                    willHidden: false,
                });
            }, 400);
        };
        this.contentClick = (e) => {
            e.stopPropagation && e.stopPropagation();
            if (e.nativeEvent) {
                e.nativeEvent.stopPropagation();
            }
        };
        this.state = {
            show: props.visible,
            willHidden: false,
        };
    }
    componentDidUpdate(preProps) {
        if (preProps.visible && !this.props.visible) {
            // 隐藏
            this.transitionHiddenModal();
        }
        else if (!preProps.visible && this.props.visible) {
            // 显示
            this.transitionShowModal();
        }
    }
    render() {
        const { visible, content, close, cancelText, ok, okText, className, animateIn, animateOut, translateX = 0, translateY = 0 } = this.props;
        const { show, willHidden } = this.state;
        const confirmCls = classnames('cfm_confirm', className);
        return (<ModalContainer visible={visible || show} className={confirmCls}>
        <div>
          <div className='cfm_modal_mask'/>
          <div className='cfm_confirm_wrap' onClick={this.wrapClick} style={{ 'transform': `translate(${translateX}px, ${translateY}px)` }}>
            <div className={classnames('cfm_confirm_container', animateIn && show && `cfm_confirm_${animateIn}_will_show`, animateOut && willHidden && `cfm_confirm_${animateOut}_will_hidden`)} onClick={(e) => this.contentClick(e)}>
              <div className='cfm_confirm_content'>
                {content}
              </div>
              <div className='cfm_confirm_btn'>
                {cancelText ? <div onClick={close} className='cfm_confirm_button cfm_confirm_cancel'>{cancelText || 'Cancel'}</div> : null}
                {okText ? <div onClick={ok} className='cfm_confirm_button cfm_confirm_ok'>{okText || 'Ok'}</div> : null}
              </div>
            </div>
          </div>
        </div>
      </ModalContainer>);
    }
}
ConfirmModal.defaultProps = {
    animateIn: 'zoom',
    animateOut: 'zoom',
};
function confirm(config) {
    if (!document) {
        return {
            destroy: () => { },
            update: () => { },
        };
    }
    const div = document.createElement('div');
    document.body.appendChild(div);
    let currentConfig = Object.assign(Object.assign({}, config), { ok, close, visible: true });
    function ok(...args) {
        currentConfig = Object.assign(Object.assign({}, currentConfig), { visible: false });
        render(currentConfig);
        config.onOk && config.onOk();
        setTimeout(() => {
            destroy(...args);
        }, 400);
    }
    function close(...args) {
        currentConfig = Object.assign(Object.assign({}, currentConfig), { visible: false });
        render(currentConfig);
        config.onCancel && config.onCancel();
        setTimeout(() => {
            destroy(...args);
        }, 400);
    }
    function update(newConfig) {
        currentConfig = Object.assign(Object.assign({}, currentConfig), newConfig);
        render(currentConfig);
    }
    function destroy(...args) {
        const unmountResult = ReactDOM.unmountComponentAtNode(div);
        if (unmountResult && div.parentNode) {
            div.parentNode.removeChild(div);
        }
        const triggerCancel = args && args.length && args.some(param => param && param.triggerCancel);
        if (config.onCancel && triggerCancel) {
            config.onCancel(...args);
        }
    }
    function render(props) {
        ReactDOM.render(<ConfirmModal {...props}/>, div);
    }
    render(currentConfig);
    return {
        destroy: close,
        update,
    };
}
export default confirm;



// WEBPACK FOOTER //
// ./components/modal/Confirm.tsx